import {Track} from '../../core/_models/_tracks-models'
import {TrackStatusItem} from './TrackStatusItem'
import {FormattedMessage, useIntl} from 'react-intl'
import {useQuery} from 'react-query'
import {getParcelStatuses} from '../../../parcels/core/_requests'
import {getTrackStatuses} from '../../core/_requests'
import {useEffect} from 'react'
import {MenuComponent} from '../../../../../_metronic/assets/ts/components'
import {CParcelStatusItem} from '../../../parcels/parcel-page/status/CParcelStatusItem'
import {ParcelStatusItem} from '../../../parcels/parcel-page/status/ParcelStatusItem'
import {CTrackStatusItem} from './CTrackStatusItem'

interface Props {
  track: Track
}

export function TrackStatus({track}: Props) {
  const intl = useIntl()
  const {data: trackStatuses} = useQuery(
    ['trackStatuses', intl.locale, track.id],
    () => {
      return getTrackStatuses(track.id)
    },
    {keepPreviousData: true, retry: false}
  )

  const {status_logs} = track
  return (
    <div className='card mb-5 mb-xl-10 pt-10'>
      <div className='card-body py-9 px-20 cardBody'>
        <div className='table-responsive'>
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bold text-muted'>
                <th className='min-w-190px'>
                  <FormattedMessage id='PARCELS.P_PAGE.STATUSES.DATE_COLUMN' />
                </th>

                <th className='min-w-120px'>
                  <FormattedMessage id='PARCELS.P_PAGE.STATUSES.STATUS_COLUMN' />
                </th>
                <th className='min-w-100px'>
                  <FormattedMessage id='PARCELS.P_PAGE.STATUSES.AUTHOR_COLUMN' />
                </th>
              </tr>
            </thead>

            <tbody>
              {trackStatuses?.statusLogs?.length &&
                trackStatuses.statusLogs?.map((item: any, index: number) => (
                  <CTrackStatusItem key={index} log={item} />
                ))}
              {!trackStatuses?.statusLogs?.length &&
                status_logs?.map((item) => <TrackStatusItem key={item.id} log={item} />)}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
